import { createAnchorLinkCache } from "../../../utils/anchorLinks/anchorLinkCache.js";
import { getAnchorLinksFromTextSectionContent } from "../../../utils/anchorLinks/lib.js";
const getTextBuilderTextId = ({
  uniqueId,
  type,
  text
}) => uniqueId ? `${uniqueId}-${type}-${text}` : `${type}-${text}`;
const processTextBuilderAnchorLinks = ({
  textSectionContent,
  entryId,
  uniqueId
}) => {
  const anchorLinkCache = createAnchorLinkCache();
  const links = getAnchorLinksFromTextSectionContent(textSectionContent);
  links.forEach((link) => {
    const linkId = getTextBuilderTextId({
      uniqueId,
      type: link.type,
      text: link.text
    });
    anchorLinkCache.addAnchorLink({
      groupId: entryId,
      title: link.text,
      id: linkId,
      level: link.level
    });
  });
};
export {
  getTextBuilderTextId,
  processTextBuilderAnchorLinks
};
